import axios from 'axios';
import { trackApiFailure } from 'utills/telemetry';

// Was previously a hardcoded UAT URL; now derived from the per-environment
// base URL like the rest of the app's API calls.
const DECRYPT_ENDPOINT = `${process.env.REACT_APP_API_BASE_URL}/api/decrypt`;

/**
 * Decrypts the linking mobile app's link payload via the decrypt API,
 * reporting failures to App Insights.
 * @param json the encrypted payload to send
 * @returns the decrypted payload, or `{ error }` on failure
 */
const fetchData = async (json: any) => {
  try {
    const response = await axios({
      method: 'post',
      url: DECRYPT_ENDPOINT,
      headers: {
        'Content-Type': 'application/json',
      },
      data: json,
    });

    return response.data;
  } catch (err) {
    let message = 'Information not returned, please try again later!';
    let status: number | undefined;
    if (axios.isAxiosError(err)) {
      status = err.response?.status;
      if (status === 401) {
        message = 'Unauthorized: Validation error, Incorrect url !';
      }
    }
    trackApiFailure({
      endpoint: DECRYPT_ENDPOINT,
      method: 'POST',
      status,
      errorCategory: 'DecryptLinkFailed',
    });
    return { error: message };
  }
};

export default fetchData;
